import AccordionItem from './AccordionItem'
import parse from 'html-react-parser'

const PDPAccordion = ({ desc, valueProps, nogots, age, isMarketplaceProduct }) => {
    // console.log('nogots', nogots)
    // console.log('valueProps', valueProps)

    const marketplaceItem = {
        title: 'Brands We Love',
        description: 'Discover trusted brands we love. Each thoughtfully selected for safety, quality, and style. We’ve partnered with brands that share our commitment to families, so every marketplace find is handpicked, parent-approved, and the perfect complement to your Monica + Andy favorites.'
    }

    const deliveryItem = {
        title: 'Delivery + Returns',
        description: 'Free shipping over $75 (contiguous U.S.). Changed your mind? Send back unworn, unwashed items within 90 days—on us.'
    }

    return (
        <div className="accordion-outer">
            <div className="accordion-inner">
                <ul className="accordion-list nostyle">
                    {desc && (
                        <AccordionItem
                            itemData={desc}
                            key="product-details-00"
                            type="desc"
                            nogots={nogots}
                            age={age}
                        />
                    )}
                    {valueProps &&
                        valueProps.map((item, index) => {
                            return (
                                <AccordionItem
                                    itemData={item}
                                    key={index}
                                    index={index}
                                    type="valueProp"
                                />
                            )
                        })}
                    {isMarketplaceProduct && (
                        <AccordionItem
                            itemData={marketplaceItem}
                            key="product-details-01"
                            type="marketplace"
                        />
                    )}
                    {!isMarketplaceProduct && (
                        <AccordionItem
                            itemData={deliveryItem}
                            key="product-details-02"
                            type="delivery"
                        />
                    )}
                </ul>
            </div>
        </div>
    )
}

export default PDPAccordion
